export default __webpack_public_path__ + "static/media/2464.7468904a.png";